/**
 * <Loader> — themed activity indicator (atom).
 *
 * Thin token-driven wrapper over React Native's `ActivityIndicator`.
 * Layout centering is the caller's job (e.g. `<Stack align="center">`). No hex.
 */
import React from "react"
import { ActivityIndicator, type StyleProp, type ViewStyle } from "react-native"
import { useUnistyles } from "react-native-unistyles"

import { type SemanticColorKey } from "../../theme/tokens/colors"

export type LoaderProps = {
    /** Spinner size — defaults to `large`. */
    size?: "small" | "large"
    /** Spinner color token — defaults to `primary`. */
    color?: SemanticColorKey
    style?: StyleProp<ViewStyle>
    testID?: string
}

export function Loader(props: LoaderProps) {
    const { size = "large", color = "primary", style, testID } = props
    const { theme } = useUnistyles()

    return <ActivityIndicator testID={testID} size={size} color={theme.colors[color]} style={style} />
}
